import { render, staticRenderFns } from "./DataCorrectionEscalationFile.vue?vue&type=template&id=7645cc00&scoped=true&"
import script from "./DataCorrectionEscalationFile.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionEscalationFile.vue?vue&type=style&index=0&id=7645cc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645cc00",
  null
  
)

export default component.exports